import { createAction } from "@reduxjs/toolkit";

export const globalStateReset = createAction("globalStateReset");
export const loadUserDetails = createAction("loadUserDetails");
export const loadCorrlinksUserDetails = createAction<any>("loadCorrlinksUserDetails");
export const loadSettings = createAction("loadSettings");
export const loadRecipients = createAction("loadRecipients");
export const fetchRecipients = createAction("fetchRecipients");
export const fetchStates = createAction("fetchStates");
export const fetchAgencies = createAction("fetchAgencies");